import React from 'react';
import { XIcon, PhoneIcon, MailIcon, ClockIcon, CalendarIcon, AlertCircleIcon, ServerIcon, DatabaseIcon, WifiIcon, ShieldIcon, CloudIcon, TagIcon, MapPinIcon, CodeIcon } from 'lucide-react';
interface AssetDrawerProps {
  asset: any;
  isOpen: boolean;
  onClose: () => void;
}
export const AssetDrawer: React.FC<AssetDrawerProps> = ({
  asset,
  isOpen,
  onClose
}) => {
  if (!asset) return null;
  // Get icon based on asset type
  const getAssetIcon = () => {
    if (asset.type === 'region' || asset.type === 'poi') {
      return <MapPinIcon size={24} className="text-accent-info" data-id="element-276" />;
    }
    switch (asset.category) {
      case 'server':
        return <ServerIcon size={24} className="text-accent-info" data-id="element-277" />;
      case 'software':
        return <CodeIcon size={24} className="text-accent-info" data-id="element-278" />;
      case 'network':
        return <WifiIcon size={24} className="text-accent-info" data-id="element-279" />;
      case 'security':
        return <ShieldIcon size={24} className="text-accent-info" data-id="element-280" />;
      case 'digital':
        return <CloudIcon size={24} className="text-accent-info" data-id="element-281" />;
      default:
        return <TagIcon size={24} className="text-accent-info" data-id="element-282" />;
    }
  };
  // Get status color based on asset status
  const getStatusColor = () => {
    switch (asset.status) {
      case 'active':
        return 'bg-green-100 text-green-800';
      case 'maintenance':
        return 'bg-yellow-100 text-yellow-800';
      case 'expiring':
        return 'bg-orange-100 text-orange-800';
      case 'critical':
        return 'bg-red-100 text-red-800';
      case 'validation':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  // Get classification color based on asset classification
  const getClassificationColor = () => {
    switch (asset.classification) {
      case 'sangat-rahasia':
        return 'bg-red-100 text-red-800';
      case 'rahasia':
        return 'bg-orange-100 text-orange-800';
      case 'terbuka':
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <div className={`fixed inset-y-0 right-0 w-full sm:w-96 bg-white shadow-xl transform transition-transform duration-300 z-50 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-283">
      <div className="flex flex-col h-full" data-id="element-284">
        {/* Header */}
        <div className="p-4 border-b border-gray-200 flex items-center justify-between bg-neutral-light" data-id="element-285">
          <h2 className="text-lg font-bold text-secondary flex items-center" data-id="element-286">
            {getAssetIcon()}
            <span className="ml-2" data-id="element-287">Ringkasan Aset</span>
          </h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-200" data-id="element-288">
            <XIcon size={20} className="text-gray-500" data-id="element-289" />
          </button>
        </div>
        {/* Content */}
        <div className="flex-1 overflow-y-auto p-4" data-id="element-290">
          {asset.type === 'region' ?
        // Region summary
        <div className="space-y-4" data-id="element-291">
              <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-292">
                <h3 className="text-lg font-medium text-secondary" data-id="element-293">
                  {asset.name}
                </h3>
                <p className="text-sm text-gray-600 mt-1" data-id="element-294">
                  Ringkasan wilayah regional
                </p>
              </div>
              <div className="bg-neutral-light p-4 rounded-lg" data-id="element-295">
                <h4 className="text-sm font-medium text-secondary mb-2" data-id="element-296">
                  Statistik Aset
                </h4>
                <div className="space-y-2" data-id="element-297">
                  <div className="flex justify-between" data-id="element-298">
                    <span className="text-sm text-gray-600" data-id="element-299">Total Aset:</span>
                    <span className="text-sm font-medium" data-id="element-300">187</span>
                  </div>
                  <div className="flex justify-between" data-id="element-301">
                    <span className="text-sm text-gray-600" data-id="element-302">Nilai Total:</span>
                    <span className="text-sm font-medium" data-id="element-303">Rp 450M</span>
                  </div>
                  <div className="flex justify-between" data-id="element-304">
                    <span className="text-sm text-gray-600" data-id="element-305">Aset Kritis:</span>
                    <span className="text-sm font-medium text-red-600" data-id="element-306">12</span>
                  </div>
                  <div className="flex justify-between" data-id="element-307">
                    <span className="text-sm text-gray-600" data-id="element-308">
                      Kontrak Akan Habis:
                    </span>
                    <span className="text-sm font-medium text-orange-600" data-id="element-309">
                      8
                    </span>
                  </div>
                </div>
              </div>
              <div className="bg-neutral-light p-4 rounded-lg" data-id="element-310">
                <h4 className="text-sm font-medium text-secondary mb-2" data-id="element-311">
                  Kontak Kepala Regional
                </h4>
                <div className="space-y-2" data-id="element-312">
                  <div className="flex items-center" data-id="element-313">
                    <span className="text-sm text-gray-600 w-24" data-id="element-314">Nama:</span>
                    <span className="text-sm" data-id="element-315">Ir. Budi Santoso</span>
                  </div>
                  <div className="flex items-center" data-id="element-316">
                    <span className="text-sm text-gray-600 w-24" data-id="element-317">Telepon:</span>
                    <a href="tel:+6281234567890" className="text-sm text-accent-info hover:underline flex items-center" data-id="element-318">
                      <PhoneIcon size={14} className="mr-1" data-id="element-319" />
                      +62 812-3456-7890
                    </a>
                  </div>
                  <div className="flex items-center" data-id="element-320">
                    <span className="text-sm text-gray-600 w-24" data-id="element-321">Email:</span>
                    <a href="mailto:budi.santoso@bin.go.id" className="text-sm text-accent-info hover:underline flex items-center" data-id="element-322">
                      <MailIcon size={14} className="mr-1" data-id="element-323" />
                      budi.santoso@bin.go.id
                    </a>
                  </div>
                </div>
              </div>
            </div> : asset.type === 'poi' ?
        // POI summary
        <div className="space-y-4" data-id="element-324">
              <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-325">
                <h3 className="text-lg font-medium text-secondary" data-id="element-326">
                  {asset.name}
                </h3>
                <p className="text-sm text-gray-600 mt-1" data-id="element-327">Point of Interest</p>
              </div>
              <div className="bg-neutral-light p-4 rounded-lg" data-id="element-328">
                <h4 className="text-sm font-medium text-secondary mb-2" data-id="element-329">
                  Statistik Aset
                </h4>
                <div className="space-y-2" data-id="element-330">
                  <div className="flex justify-between" data-id="element-331">
                    <span className="text-sm text-gray-600" data-id="element-332">Total Aset:</span>
                    <span className="text-sm font-medium" data-id="element-333">312</span>
                  </div>
                  <div className="flex justify-between" data-id="element-334">
                    <span className="text-sm text-gray-600" data-id="element-335">Nilai Total:</span>
                    <span className="text-sm font-medium" data-id="element-336">Rp 280M</span>
                  </div>
                  <div className="flex justify-between" data-id="element-337">
                    <span className="text-sm text-gray-600" data-id="element-338">Aset Kritis:</span>
                    <span className="text-sm font-medium text-red-600" data-id="element-339">18</span>
                  </div>
                  <div className="flex justify-between" data-id="element-340">
                    <span className="text-sm text-gray-600" data-id="element-341">
                      Kontrak Akan Habis:
                    </span>
                    <span className="text-sm font-medium text-orange-600" data-id="element-342">
                      15
                    </span>
                  </div>
                </div>
              </div>
              <div className="bg-neutral-light p-4 rounded-lg" data-id="element-343">
                <h4 className="text-sm font-medium text-secondary mb-2" data-id="element-344">
                  Kontak Penanggung Jawab
                </h4>
                <div className="space-y-2" data-id="element-345">
                  <div className="flex items-center" data-id="element-346">
                    <span className="text-sm text-gray-600 w-24" data-id="element-347">Nama:</span>
                    <span className="text-sm" data-id="element-348">Dr. Ani Wijaya</span>
                  </div>
                  <div className="flex items-center" data-id="element-349">
                    <span className="text-sm text-gray-600 w-24" data-id="element-350">Telepon:</span>
                    <a href="tel:+6281234567891" className="text-sm text-accent-info hover:underline flex items-center" data-id="element-351">
                      <PhoneIcon size={14} className="mr-1" data-id="element-352" />
                      +62 812-3456-7891
                    </a>
                  </div>
                  <div className="flex items-center" data-id="element-353">
                    <span className="text-sm text-gray-600 w-24" data-id="element-354">Email:</span>
                    <a href="mailto:ani.wijaya@stin.ac.id" className="text-sm text-accent-info hover:underline flex items-center" data-id="element-355">
                      <MailIcon size={14} className="mr-1" data-id="element-356" />
                      ani.wijaya@stin.ac.id
                    </a>
                  </div>
                </div>
              </div>
            </div> :
        // Individual asset
        <div className="space-y-4" data-id="element-357">
              <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-358">
                <div className="flex justify-between" data-id="element-359">
                  <h3 className="text-lg font-medium text-secondary" data-id="element-360">
                    {asset.name}
                  </h3>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor()}`} data-id="element-361">
                    {asset.status === 'active' ? 'Aktif' : asset.status === 'maintenance' ? 'Perlu Perawatan' : asset.status === 'expiring' ? 'Akan Habis' : asset.status === 'critical' ? 'Kritis' : 'Perlu Validasi'}
                  </span>
                </div>
                <p className="text-sm text-gray-600 mt-1" data-id="element-362">ID: {asset.id}</p>
              </div>
              <div className="bg-neutral-light p-4 rounded-lg" data-id="element-363">
                <h4 className="text-sm font-medium text-secondary mb-2" data-id="element-364">
                  Informasi Umum
                </h4>
                <div className="space-y-2" data-id="element-365">
                  <div className="flex items-center" data-id="element-366">
                    <span className="text-sm text-gray-600 w-32" data-id="element-367">Unit:</span>
                    <span className="text-sm" data-id="element-368">{asset.location}</span>
                  </div>
                  <div className="flex items-center" data-id="element-369">
                    <span className="text-sm text-gray-600 w-32" data-id="element-370">
                      Kategori:
                    </span>
                    <span className="text-sm" data-id="element-371">
                      {asset.category === 'server' ? 'Server & Komputasi' : asset.category === 'software' ? 'Software & Lisensi' : asset.category === 'network' ? 'Jaringan & Komunikasi' : asset.category === 'security' ? 'Keamanan Siber' : 'Infrastruktur Digital'}
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-372">
                    <span className="text-sm text-gray-600 w-32" data-id="element-373">Tipe:</span>
                    <span className="text-sm" data-id="element-374">{asset.type}</span>
                  </div>
                  <div className="flex items-center" data-id="element-375">
                    <span className="text-sm text-gray-600 w-32" data-id="element-376">
                      Nilai Aset:
                    </span>
                    <span className="text-sm font-medium" data-id="element-377">{asset.value}</span>
                  </div>
                  <div className="flex items-center" data-id="element-378">
                    <span className="text-sm text-gray-600 w-32" data-id="element-379">
                      Klasifikasi:
                    </span>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${getClassificationColor()}`} data-id="element-380">
                      {asset.classification === 'sangat-rahasia' ? 'Sangat Rahasia' : asset.classification === 'rahasia' ? 'Rahasia' : 'Terbuka'}
                    </span>
                  </div>
                </div>
              </div>
              <div className="bg-neutral-light p-4 rounded-lg" data-id="element-381">
                <h4 className="text-sm font-medium text-secondary mb-2" data-id="element-382">
                  Tanggal & Status
                </h4>
                <div className="space-y-2" data-id="element-383">
                  <div className="flex items-center" data-id="element-384">
                    <span className="text-sm text-gray-600 w-32" data-id="element-385">
                      Terakhir Diperbarui:
                    </span>
                    <span className="text-sm flex items-center" data-id="element-386">
                      <ClockIcon size={14} className="mr-1 text-gray-500" data-id="element-387" />
                      {asset.lastUpdate}
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-388">
                    <span className="text-sm text-gray-600 w-32" data-id="element-389">
                      Tanggal Berakhir:
                    </span>
                    <span className="text-sm flex items-center" data-id="element-390">
                      <CalendarIcon size={14} className="mr-1 text-gray-500" data-id="element-391" />
                      {asset.expiry}
                    </span>
                  </div>
                  {asset.status === 'critical' && <div className="mt-2 p-2 bg-red-50 rounded-lg border border-red-100" data-id="element-392">
                      <div className="flex items-start" data-id="element-393">
                        <AlertCircleIcon size={16} className="text-red-600 mt-0.5 mr-2 flex-shrink-0" data-id="element-394" />
                        <span className="text-sm text-red-700" data-id="element-395">
                          {asset.issue}
                        </span>
                      </div>
                    </div>}
                </div>
              </div>
              <div className="bg-neutral-light p-4 rounded-lg" data-id="element-396">
                <h4 className="text-sm font-medium text-secondary mb-2" data-id="element-397">
                  Kontak Cepat
                </h4>
                <div className="space-y-4" data-id="element-398">
                  <div data-id="element-399">
                    <p className="text-sm font-medium mb-1" data-id="element-400">
                      PIC (Person in Charge):
                    </p>
                    <div className="flex flex-col" data-id="element-401">
                      <span className="text-sm" data-id="element-402">{asset.pic}</span>
                      <a href={`tel:${asset.picContact}`} className="text-sm text-accent-info hover:underline flex items-center mt-1" data-id="element-403">
                        <PhoneIcon size={14} className="mr-1" data-id="element-404" />
                        {asset.picContact}
                      </a>
                    </div>
                  </div>
                  <div data-id="element-405">
                    <p className="text-sm font-medium mb-1" data-id="element-406">Vendor/Supplier:</p>
                    <div className="flex flex-col" data-id="element-407">
                      <span className="text-sm" data-id="element-408">{asset.vendor}</span>
                      <a href={`tel:${asset.vendorContact}`} className="text-sm text-accent-info hover:underline flex items-center mt-1" data-id="element-409">
                        <PhoneIcon size={14} className="mr-1" data-id="element-410" />
                        {asset.vendorContact}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
        </div>
        {/* Footer */}
        <div className="p-4 border-t border-gray-200" data-id="element-411">
          <button className="w-full bg-secondary text-white py-2 rounded-md hover:bg-opacity-90 flex items-center justify-center" data-id="element-412">
            {asset.type === 'region' || asset.type === 'poi' ? <>Lihat Semua Aset</> : <>Detail Aset Lengkap</>}
          </button>
        </div>
      </div>
    </div>;
};